import formatCurrencyConstrained from './formatCurrencyConstrained';
export default formatCurrencyConstrained;